import { Component } from "react";
import { RPCRequests } from "src/modules/communication-protobuf";
import { Flex, Spinner } from "@chakra-ui/react";
import Dialog from "src/components/Dialog";
import NavigationBar from "src/components/NavigationBar";
import View from "./View";

const log = window.require("electron-log");

export default class EveryNoise extends Component {
  state = {
    error: false,
    loading: true
  };

  async componentDidMount() {
    try {
      const { primaryStation } = this.props.parentStation;
      const { rpc } = primaryStation;
      const request = RPCRequests.StartListening.create();
      await rpc.call(request, primaryStation.jid);
      this.setState({ loading: false });
    } catch (error) {
      log.error(error);
      this.setState({ error: true });
    }
  }

  componentWillUnmount() {
    const { error } = this.state;
    if (!error) {
      const { primaryStation } = this.props.parentStation;
      const { rpc } = primaryStation;

      const request = RPCRequests.StopListening.create();
      rpc.call(request, primaryStation.jid);
    }
  }

  handleDialogDismiss = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { error, loading } = this.state;
    const { t, onClose, parentStation } = this.props;
    const { getMonitoredAvatar, primaryStation } = parentStation;
    const { noiseMeter } = primaryStation;

    const monitoredAvatar = getMonitoredAvatar();

    return (
      <>
        <Dialog
          isOpen={error}
          heading={t("parentStation.everyNoise.failureDialog.heading")}
          text={t("messages.tryLater")}
          buttons={[{ text: t("buttons.ok"), onClick: onClose }]}
        />
        <NavigationBar headingKey="everyNoise" onClose={onClose} />
        {!error && (
          <Flex
            justifyContent="center"
            alignItems="center"
            height="calc(100% - 61px)"
          >
            {loading ? (
              <Spinner />
            ) : (
              <View avatar={monitoredAvatar} noiseMeter={noiseMeter} />
            )}
          </Flex>
        )}
      </>
    );
  }
}
